import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select.tsx'
import { cn } from '@/lib/utils.ts'
import useGlobalStore from '@/useGlobalStore.ts'

const NavLanguageSelector = () => {
	const { learningLanguageCode, availableLearningLanguages, changeLearningLanguage } = useGlobalStore()
	const isCollapsed = false

	return (
		learningLanguageCode !== '' && (
			<Select defaultValue={learningLanguageCode} onValueChange={(lang) => changeLearningLanguage(lang)}>
				<SelectTrigger
					className={cn(
						'flex items-center gap-2 [&>span]:line-clamp-1 [&>span]:flex w-auto [&>span]:w-full [&>span]:items-center [&>span]:gap-1 [&>span]:truncate bg-input border-none',
						isCollapsed &&
							'flex h-9 w-9 shrink-0 items-center justify-center p-0 [&>span]:w-auto [&>svg]:hidden',
					)}
					aria-label="Select account">
					<SelectValue placeholder="Select a language">
						<span className={`w-5 fi fi-${availableLearningLanguages[learningLanguageCode]?.icon}`}></span>
						<span className={cn('ml-2 rtl:mt-0.5', isCollapsed && 'hidden')}>
							{learningLanguageCode.substring(0, 2).toUpperCase()}
						</span>
					</SelectValue>
				</SelectTrigger>
				<SelectContent>
					{Object.entries(availableLearningLanguages).map(([key, lang]) => (
						<SelectItem key={key} value={key}>
							<div className="flex items-center gap-3">
								<span className={`w-5 fi fi-${lang?.icon}`}></span>
								{lang.name}
							</div>
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		)
	)
}

export default NavLanguageSelector
